type StoredToken = {
  token?: unknown;
};

function decodeBase64Url(value: string) {
  const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64.padEnd(
    base64.length + ((4 - (base64.length % 4)) % 4),
    "=",
  );
  return atob(padded);
}

function isJwtExpired(token: string) {
  const [, payload] = token.split(".");
  if (!payload) return false;

  try {
    const decoded = JSON.parse(decodeBase64Url(payload));
    if (typeof decoded?.exp !== "number") return false;

    return decoded.exp * 1000 <= Date.now();
  } catch {
    return false;
  }
}

export function getStoredAccessToken(): string | null {
  try {
    const raw = localStorage.getItem("token");
    if (!raw || raw === "undefined" || raw === "null") return null;

    const parsed = JSON.parse(raw) as StoredToken;
    const token = parsed?.token;
    if (typeof token !== "string" || !token.trim()) return null;
    if (isJwtExpired(token)) return null;

    return token;
  } catch {
    return null;
  }
}

export function hasStoredAccessToken() {
  return !!getStoredAccessToken();
}
